import { set, get, remove } from "./state.js";
import { app, updateMenu } from "./app.js";
import useAuth from "./firebase.js";
import useGrpc from "./grpc.js";
import alertify from "alertifyjs";
import "regenerator-runtime/runtime";
import { sha256 } from "js-sha256";
import { hideSpinner, showSpinner } from "./fullscreenSpinner.js";

const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const auth = useAuth();
const grpc = useGrpc();

// takes a logged in user and attempts to retrieve their data from the grpc server
// and set that data in local storage
export const setUser = async () => {
  const user = auth.getCurrentUser();
  if (!user) return false;

  const data = await grpc.getUserData();
  console.log("USERDATA", data);
  if (!data) return false;

  const score = await grpc.getUserScore();
  console.log("SCORE", score);
  if (!score) return false;

  const success = storeAccountData(data.user, score.score);

  return true;
};

// returns true if all required fields were successfully stored
function storeAccountData(userData, score) {
  let success = true;

  if (!set("id", userData.userId)) return (success = false);
  if (!set("email", userData.email)) return (success = false);
  if (!set("accountType", userData.accountType)) return (success = false);
  if (!set("username", userData.leaderboardName)) return (success = false);
  if (!set("fname", userData.firstName)) return (success = false);
  if (!set("lname", userData.lastName)) return (success = false);
  if (!set("grade", userData.grade)) return (success = false);
  if (!set("score", score)) return (success = false);
  if (!set("school", userData.school)) return (success = false);
  if (!set("county", userData.county)) return (success = false);
  if (!set("interestedPathways", JSON.stringify(userData.pathwaysList)))
    return (success = false);
  if (!set("timestamp", Math.floor(Date.now() / 1000)))
    return (success = false);

  return success;
}

function doLogin(evt) {
  evt.preventDefault();

  showSpinner();

  const username = document
    .querySelector("#create-username")
    .value.toLowerCase();
  const password = document.querySelector("#create-password").value;

  if (username === "") {
    hideSpinner();
    alertify.error("Username must not be empty");

    return;
  }

  if (password === "") {
    hideSpinner();
    alertify.error("Password must not be empty");

    return;
  }

  //Note: we have to run the password with sha256 and without because some
  // users we're created with and some without. We need to support both.
  auth
    .signIn({ email: username.trim(), password: sha256(password) })
    .then(async (user) => {
      if (!user || user.hasOwnProperty("error")) {
        user = await auth.signIn({
          email: username.trim(),
          password: password,
        });
        if (!user || user.hasOwnProperty("error")) {
          hideSpinner();
          alertify.error("Username or password is incorrect");
          return;
        }
      }

      const success = await setUser();
      console.log("SUCCESS", success);
      if (!success) {
        console.log("here");
        //   destroyLoginSession();
        //   alertify.error("Network Error! Unable to login. Please try again.");

        // A failure here means most likely that the user hasn't filled out
        // their profile data yer. We should just redirect them to the signup page.
        // if (!window.location.pathname === app.signup)
        set("need-profile-info", true);
        hideSpinner();
        window.location.replace(app.signup);
        return;
      }

      // successfully logged in and user data is stored
      set("need-profile-info", false);
      hideSpinner();
      alertify.success("Login successful!");
      alertify.success("Starting app now...");
      window.location.replace(app.home);
    });
}

export async function destroyLoginSession() {
  await auth.signOut();

  // set and remove are intentional here
  // remove alone would be fine in most cases but the set here ensures that changes are possible
  const success = set("id", "");
  remove("id");
  remove("email");
  remove("accountType");
  remove("username");
  remove("fname");
  remove("lname");
  remove("grade");
  remove("score");
  remove("school");
  remove("county");
  remove("interestedPathways");
  remove("timestamp");
  remove("need-profile-info");

  return success;
}

function doLoginOnEnterKey(evt) {
  if (evt.key.toLowerCase() === "enter") {
    evt.preventDefault();
    doLogin(evt);
  }
}

export function login() {
  const loginBtn = document.querySelector("#itp-login-button");
  const username = document.querySelector("#create-username");
  const password = document.querySelector("#create-password");

  loginBtn.onclick = doLogin;
  username.onkeyup = password.onkeyup = doLoginOnEnterKey;
}

export function logout() {
  const success = destroyLoginSession();

  if (success) {
    alertify.success("Logout successful!");
    updateMenu();
  } else {
    alertify.error(
      "Browser error! Please try a different browser or use the mobile app."
    );
  }
}

export default {};
